<script setup>
defineProps({
    items: { type: Array, required: true },
})
</script>

<template>
    <nav aria-label="Drobečková navigace">
        <ol class="flex flex-wrap items-center gap-x-2 gap-y-1 text-sm text-zinc-500">
            <li
                class="flex items-center gap-2"
                v-for="(item, index) in items"
                :key="item.url"
            >
                <span
                    class="text-zinc-300"
                    v-if="index > 0"
                    aria-hidden="true"
                >
                    /
                </span>

                <span
                    class="text-brand-900 font-medium"
                    v-if="index === items.length - 1"
                    aria-current="page"
                >
                    {{ item.name }}
                </span>

                <Link
                    class="hover:text-brand-900 underline-offset-4 hover:underline"
                    v-else
                    :href="item.url"
                >
                    {{ item.name }}
                </Link>
            </li>
        </ol>
    </nav>
</template>
